import { db } from '../';


export const deletePersonalGuidedMindSweep = ({ personalGuidedMindSweepKey }) => {
  return db.collection('personal-guided-mind-sweeps').doc(personalGuidedMindSweepKey).delete();
};